<template>
  <Accordion
    :class="[
      'filter-category border rounded',
      {
        'border-alto': !hasAppliedFilters,
        'bg-black-squeeze border-deep-cerulean': hasAppliedFilters,
        'bg-alabaster': open && !hasAppliedFilters,
        'hover:bg-alabaster': !open && !hasAppliedFilters
      }
    ]"
    :open="open"
  >
    <template #button>
      <FilterCategoryButton
        :name="name"
        :open="open"
        :description="appliedFiltersDescription"
        @clear="onClear"
        @toggle="onToggle"
      />
    </template>

    <template #content>
      <div class="flex text-xs px-3 py-2">
        <div class="filter-items-column flex flex-col flex-1">
          <FilterItem
            class="pb-2"
            :checked="Boolean(appliedFilters[filter.id])"
            :count="filter.count"
            :id="filter.id"
            :name="filter.name"
            :multiselect="isMultiselect"
            @change="onFilterChange"
            :key="filter.id"
            v-for="filter in leftFilters"
          />
        </div>
        <div class="filter-items-column flex flex-col flex-1">
          <FilterItem
            class="pb-2"
            :checked="Boolean(appliedFilters[filter.id])"
            :count="filter.count"
            :id="filter.id"
            :name="filter.name"
            :multiselect="isMultiselect"
            @change="onFilterChange"
            :key="filter.id"
            v-for="filter in rightFilters"
          />
        </div>
      </div>
    </template>
  </Accordion>
</template>

<script>
import { Accordion } from '@listen360/alexandria'
import FilterCategoryButton from './FilterCategoryButton'
import FilterItem from './FilterItem'

export default {
  name: 'FilterCategory',
  components: {
    Accordion,
    FilterCategoryButton,
    FilterItem
  },
  props: {
    appliedFilters: {
      type: Object,
      default() {
        return {}
      }
    },
    filters: {
      type: Array,
      default() {
        return []
      }
    },
    id: {
      required: true,
      validator: function(value) {
        return ['number', 'string'].includes(typeof value)
      }
    },
    name: {
      type: String,
      required: true
    },
    open: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    appliedFiltersDescription() {
      return Object.keys(this.appliedFilters)
        .map(key => this.appliedFilters[key].name)
        .join(', ')
    },
    hasAppliedFilters() {
      return Object.keys(this.appliedFilters).length > 0
    },
    isMultiselect() {
      return this.type === 'multiselect'
    },
    leftFilters() {
      const endIndex = Math.ceil(this.filters.length / 2)
      return this.filters.slice(0, endIndex)
    },
    rightFilters() {
      const startIndex = Math.ceil(this.filters.length / 2)
      return this.filters.slice(startIndex)
    }
  },
  methods: {
    onClear() {
      this.$emit('clear', this.id)
    },
    onFilterChange({ id, name }) {
      let newAppliedFilters

      if (this.isMultiselect && this.appliedFilters[id]) {
        newAppliedFilters = {
          ...this.appliedFilters
        }
        delete newAppliedFilters[id]
      } else if (this.isMultiselect) {
        newAppliedFilters = {
          ...this.appliedFilters,
          [id]: { id, name, categoryId: this.id, categoryName: this.name }
        }
      } else {
        newAppliedFilters = {
          [id]: { id, name, categoryId: this.id, categoryName: this.name }
        }
      }

      this.$emit('change', { categoryId: this.id, filters: newAppliedFilters })
    },
    onToggle() {
      this.$emit('toggle', this.id)
    }
  }
}
</script>
